module.exports = __webpack_public_path__ + "img/parking.a58bde60.svg";